import React, { useState } from 'react';
import { useMutation } from "@apollo/client/react";
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';

export const ModificarModal = ({ onAccept }) => {
    const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => {
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <>
            <div aria-hidden='true' onClick={handleOpenModal} className='item-option clickable-option'>
                <EditIcon className='edit-icon' />
                <span className='toggle-action'>Modificar</span>
            </div>
            <CustomDialog
                maxWidth="sm"
                fullWidth={true}
                open={openModal}
                title={'Modificar Visita'}
                onCancel={handleCloseModal}
                onAccept={onAccept}
                acceptText='Continuar'
                cancelText='Cancelar'
            >
                Está por entrar a modificar la visita, ¿Desea continuar?
            </CustomDialog>
        </>);

};